module.exports = __webpack_public_path__ + "static/img/b3.c702cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b3.jpg
// module id = 248
// module chunks = 0 1 2 3 4 5 6 7 8 9